<template>
  <div
    class="modal cart-modal"
    id="cartModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div
      class="modal-dialog fadeInRight animated ms-auto modal-dialog-scrollable"
      role="document"
    >
      <div class="modal-content bg-white">
        <div class="cart-loader" v-show="cartLoading">
          <clip-loader
            :loading="cartLoading"
            :color="color"
            :size="size"
          ></clip-loader>
        </div>
        <img
          src="@/img/cart_modal_close.png"
          data-bs-dismiss="modal"
          class="cart-modal-close pointer"
        />
        <div class="modal-body p-0">
          <div class="cart-calculation-content" v-if="cart.length">
            <p class="font-18 fw-bold">Your Cart</p>
            <div
              class="cart-content bg-white py-4 px-4 mb-4"
              v-for="(item, index) in cart"
              :key="index"
            >
              <div class="d-flex align-item-center">
                <div
                  class="cart-product-img me-4 mb-2"
                  :style="{
                    background:
                      'url(' +
                      (item.images && item.images.length > 0
                        ? item.images[0]
                        : '') +
                      ')',
                  }"
                ></div>
                <div class="cart-product-details">
                  <div>
                    <span class="font-16 fw-bold">
                      {{ item.name }}
                    </span>
                  </div>
                  <div>
                    <span class="font-16 fw-bold text-theme-3">
                      {{ priceUnit }}{{ Number(item.price) | currencyFormat }}
                    </span>
                  </div>
                  <div>
                    <ul>
                      <li
                        v-for="(selection, sindex) in item.selections"
                        :key="sindex"
                        v-html="selection.selected_option"
                      ></li>
                    </ul>
                  </div>
                  <p
                    class="font-16 fw-bold text-theme-3"
                    v-show="item.stock_quantity_left"
                  >
                    {{ item.stock_quantity_left }} item left
                  </p>
                </div>
              </div>
              <div
                class="
                  calculate-price
                  d-flex
                  align-items-center
                  justify-content-between
                  pt-3
                "
              >
                <div class="d-flex align-items-center">
                  <div
                    class="dustbin bg-white pointer py-3 px-3 me-4"
                    @click="removeCartItem(index, item)"
                  >
                    <img src="@/img/dustbin.png" width="18px" />
                  </div>
                  <div
                    class="add-remove-option bg-white d-flex align-items-center"
                  >
                    <div
                      class="py-3 px-4 pointer text-center"
                      @click="reduceQuantityInCart(item)"
                    >
                      <img src="@/img/product/minus.png" width="11px" />
                    </div>
                    <div class="no-item-added py-3 px-4 pointer text-center">
                      <span class="font-14 fw-bold">{{ item.quantity }}</span>
                    </div>
                    <div
                      class="py-3 px-4 pointer text-center"
                      @click="increaseQuantityInCart(item)"
                    >
                      <img src="@/img/product/plus.png" width="11px" />
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <span class="font-16 fw-bold me-4">Total</span>
                  <span class="font-16 fw-bold"
                    >{{ priceUnit
                    }}{{ Number(item.subtotal) | currencyFormat }}</span
                  >
                </div>
              </div>
            </div>
            <div class="subtotal-price bg-white py-4 px-4 mb-3">
              <div class="d-flex align-items-center justify-content-end">
                <span class="font-20 fw-bold me-4">Subtotal</span>
                <span class="font-20 fw-bold"
                  >{{ priceUnit
                  }}{{ Number(this.cartSubTotal) | currencyFormat }}</span
                >
              </div>
            </div>
            <p class="font-16 text-end">
              Shipping, taxes, and discounts will be<br />calculated at
              checkout.
            </p>
          </div>
          <div class="cart-calculation-content" v-else>
            <p class="font-18 fw-bold">Your Cart</p>
            <p class="font-16 text-center fst-italic">
              You haven't added anything to your cart yet!
            </p>
            <div class="text-center pt-3">
              <button
                class="btn bg-theme-1 py-3 px-5"
                @click.prevent="scrollToProduct"
              >
                <span class="font-16 fw-bold text-white"
                  >Continue Shopping</span
                >
              </button>
            </div>
          </div>
          <div
            v-if="cart.length"
            class="
              checkout-btn
              bg-theme-1
              py-4
              text-center
              pointer
              d-flex
              align-items-center
              justify-content-center
              check_out_btn
            "
            @click="updateCart()"
          >
            <span
              class="
                font-18
                fw-bold
                text-white text-uppercase
                me-4
                check_out_btn
              "
              >Checkout</span
            >
            <img src="@/img/checkout_arrow.png" width="16px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

export default {
  name: "CartModal",
  props: ["products", "cart", "cartSubTotal", "priceUnit", "cartLoading"],
  components: {
    ClipLoader,
  },
  data() {
    return {
      color: "#ffffff",
      size: "40px",
    };
  },
  filters: {
    currencyFormat: function (value) {
      let val = value.toFixed(2);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  methods: {
    increaseQuantityInCart: function (cartItem) {
      this.$parent.increaseQuantityInCart(cartItem);
    },
    reduceQuantityInCart: function (cartItem) {
      this.$parent.reduceQuantityInCart(cartItem);
    },
    removeCartItem: function (index, item) {
      this.$parent.removeCartItem(index, item);
    },
    updateCart: function () {
      this.$parent.updateCart();
    },
    scrollToProduct: function () {
      this.$parent.scrollToProduct();
    },
  },
};
</script>

<style scoped>
.cart-loader {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.7;
  z-index: 999;
}
.cart-loader .v-spinner {
  top: 50%;
  position: relative;
}
</style>
